import moment from '@/plugins/vue-moment.js';

export default {
    namespaced: true,

    state: {
        filters: {
            impersonator_id: null,
            impersonated_user_id: null,
            date_start: null,
            date_end: null,
        },
    },

    getters: {
        hasFilters(state, getters) {
            return Object.keys(getters.filters).length > 0;
        },

        filters(state) {
            const params = {};

            Object.keys(state.filters).forEach(filterKey => {
                if (state.filters[filterKey] !== null && state.filters[filterKey] !== undefined) {
                    params[filterKey] = state.filters[filterKey];
                }
            });

            return params;
        },

        dates(state) {
            if (!state.filters.date_start || !state.filters.date_end) {
                return null;
            }

            return [
                moment(state.filters.date_start, 'Y-MM-DD HH:mm:ss').toDate(),
                moment(state.filters.date_end, 'Y-MM-DD HH:mm:ss').toDate(),
            ];
        },
    },

    actions: {
        setDateRange({ commit }, dateRange = []) {
            const selectedDates = Array.isArray(dateRange) ? dateRange.filter(Boolean) : dateRange ? [dateRange] : [];

            if (selectedDates.length === 0) {
                commit('SET_DATE_START', null);
                commit('SET_DATE_END', null);

                return;
            }

            const [start] = selectedDates;
            const end = selectedDates[1] || start;

            commit('SET_DATE_START', moment(start).utc().hour(0).minute(0).second(0).format('Y-MM-DD HH:mm:ss'));
            commit('SET_DATE_END', moment(end).utc().hour(23).minute(59).second(59).format('Y-MM-DD HH:mm:ss'));
        },
    },

    mutations: {
        RESET_FILTERS(state) {
            state.filters.impersonator_id = null;
            state.filters.impersonated_user_id = null;
            state.filters.date_start = null;
            state.filters.date_end = null;
        },

        SET_IMPERSONATOR_ID(state, id) {
            state.filters.impersonator_id = id;
        },

        SET_IMPERSONATED_USER_ID(state, id) {
            state.filters.impersonated_user_id = id;
        },

        SET_DATE_START(state, dateStart) {
            state.filters.date_start = dateStart;
        },

        SET_DATE_END(state, dateEnd) {
            state.filters.date_end = dateEnd;
        },
    },
};
